import { useCallback, useEffect, useState } from 'react';
import { Toast } from 'oui';
import { ToastProps, useSnackStack } from './StackingSnackbarProvider';

type StackingSnackbarToastProps = {
  toast: ToastProps;
};

const TIMEOUT = 300;

const StackingSnackbarToast: React.FC<StackingSnackbarToastProps> = ({
  toast,
}) => {
  const [open, setOpen] = useState(true);
  const { removeToast } = useSnackStack();

  const close = useCallback(() => {
    setOpen(false);
    setTimeout(() => {
      removeToast(toast.key);
    }, TIMEOUT);
  }, [toast.key, removeToast]);

  const handleClose = (reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    if (toast?.onClose) {
      toast.onClose();
    }
    close();
  };

  useEffect(() => {
    if (toast.duration !== 0) {
      setTimeout(() => {
        close();
      }, toast.duration || 800);
    }
  }, [close, toast.duration]);

  return (
    <Toast
      isOpenToast
      message={toast.message || ''}
      onClickCloseToast={handleClose}
    />
  );
};

export default StackingSnackbarToast;
